import React from 'react'
import { Spinner as UISpinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'
import { theme } from 'styles/theme'

interface Props {
  color?: string
  width?: number
  height?: number
  modal?: boolean
  className?: string
}

export const Spinner: React.FC<Props> = ({
  color = theme.palette.secondary,
  width = 32,
  height = 32,
  modal = false,
  className,
  ...props
}) => {
  return (
    <div
      className='fixed flex items-center justify-center'
      style={{
        margin: 'auto',
        top: modal ? '50%' : '50vh',
        left: modal ? '50%' : '50vw',
        transform: modal ? 'translate(-50%, -50%)' : 'translate(-50%, -50%)',
      }}
    >
      <UISpinner style={{ color, width, height }} className={cn(className)} {...props} />
    </div>
  )
}
